import flatten from 'lodash/flatten';

import { LegalEntityBranchData } from 'chaika-frontend-types/frontend-cms';

import { LegalEntityBranchApi } from '@organization/api/LegalEntityBranchApi';
import { makeBranchesWithEndData } from '@organization/queries/legalEntityBranchQueries';
import { store } from '@store';
import { getUniqNewChunkedIds } from '@utils/getUniqNewChunkedIds';
import { toArrayFromIterable } from '@utils/toArrayFromIterable';
import { LegalEntityBranchDataWithEndData } from '@organization/store/legalEntityBranch/types';

class LegalEntityBranchService {
    private loadedOrganizations = new Set<string>();
    private isLoaded = false;

    public async load(): Promise<void> {
        if (!this.isLoaded) {
            const branches = await LegalEntityBranchApi.getList();
            const withAdditionalData = this.makeListWithAdditionalData(branches);
            store.legalEntityBranchList.set(withAdditionalData);
            this.isLoaded = true;
        }
    }

    public async loadByOrganizationIds(organizationIds: string[]): Promise<void> {
        if (!this.isLoaded) {
            const newIds = getUniqNewChunkedIds(toArrayFromIterable(this.loadedOrganizations), organizationIds);

            if (newIds.length > 0) {
                const branches = flatten(
                    await Promise.all(
                        newIds.map(organizationIds =>
                            LegalEntityBranchApi.getList({ organizationId: organizationIds.join(',') }),
                        ),
                    ),
                );
                const withAdditionalData = this.makeListWithAdditionalData(branches);

                store.legalEntityBranchList.add(withAdditionalData);
                newIds.flat().forEach(organizationId => this.loadedOrganizations.add(organizationId));
            }
        }
    }

    public makeListWithAdditionalData(
        branches: (LegalEntityBranchData | LegalEntityBranchDataWithEndData)[],
    ): LegalEntityBranchDataWithEndData[] {
        return makeBranchesWithEndData(branches);
    }
}

export const legalEntityBranchService = new LegalEntityBranchService();
